module.exports = __webpack_public_path__ + "img/co2.3d15231e.svg";